import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { scrollToPartnerForm } from '@shared/components/forms/partner'
import PageAnimation from '@shared/components/page-animation'
import { PartnerLogos } from '@shared/components/sections/partner-logos'
import { ProductLoans } from '@shared/components/sections/product-loans'

import {
	comfortBlocks,
	mainBlock,
	productListLoan,
	stepsPartnersList,
} from '../../data/partners-page'

import { ComfortFormat } from './sections/comfort-format'
import { Interview } from './sections/interview'
import { Materials } from './sections/materials'
import { PartnerFormSection } from './sections/partner-form-section'
import { FooterBlock } from './sections/productLoansBlock/FooterBlock'
// import { Faq } from '@shared/components/sections/faq'
import { Socials } from './sections/socials'
import { StepsPartners } from './sections/steps-partners'

import styles from './style.module.scss'

export const View = () => (
	<PageAnimation>
		<BlockMain
			adornmentClassname={styles.mainAdornment}
			data={{
				...mainBlock,
				descriptionClassName: styles.description,
			}}
			buttonProps={{ onClick: scrollToPartnerForm }}
		/>
		<ComfortFormat blocks={comfortBlocks} />
		<PartnerLogos />
		<ProductLoans productList={productListLoan} footerBlock={<FooterBlock />} />
		<StepsPartners stepsPartnersList={stepsPartnersList} />
		<Materials socialsShow={false} />
		<Interview />
		<Socials />
		<PartnerFormSection />
		{/*<Faq accordionElements={faqPartnersPage} />*/}
		{/* В новом дизайне не нужно,
		не убираем, возможно данные компоненты можно переиспользовать
		<ProductPartners />
		<ProcessPartners />
		<InterfacePartners />
		<SupportPartners />
		<ReferalPartners />
		<Marketing />
		<Hours24 />
		<Partnership />
		*/}
	</PageAnimation>
)
